import {
  createDomesticDepositAccountApi,
  DepositAccountDomesticType,
} from '@/api/v1/organization/deposit-accounts/createDomesticDepositAccountApi';
import {
  createInternationalDepositAccountApi,
  DepositAccountInternationalType,
} from '@/api/v1/organization/deposit-accounts/createInternationalDepositAccountApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { getBankNameApi } from '@/api/v1/reference-books/getBankNameApi';
import { IDEMPOTENCY_KEY, idempotencyKeyHandler } from '@/helpers/apiHelpers/requestHelpers';

export type CreateDepositAccountUnionType = DepositAccountInternationalType | DepositAccountDomesticType;

export const createDepositAccount = async (payload: CreateDepositAccountUnionType, isDomesticPayment: boolean) => {
  const { header, clearKey } = idempotencyKeyHandler(IDEMPOTENCY_KEY.CREATE_DEPOSIT_ACCOUNT);

  try {
    const response = isDomesticPayment
      ? await createDomesticDepositAccountApi(payload as DepositAccountDomesticType, header)
      : await createInternationalDepositAccountApi(payload as DepositAccountInternationalType, header);

    clearKey();

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const loadBankName = async (routingNumber: string) => {
  try {
    const response = await getBankNameApi(routingNumber);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
